<app-search-filter
	(keyWord)="getSearchFilter($event)"
	searchKey="SERVICE.SERVICES_LIST.SEARCH"
	[showFilter]="false"
></app-search-filter>
<div class="max-tablet:block flex gap-5 mt-8">
	<div class="w-[25%] max-tablet:w-[100%]">
		<div class="mt-6 rounded">
			<mat-radio-group class="flex flex-col">
				<mat-radio-button
					*ngFor="let category of categories"
					(change)="onCategoryChanged($event)"
					[ngClass]="{
						'bg-[#FCFCFC] border-[1px] border-b-[#7E2EB3]':
							category?.id === selectedCategory?.id
					}"
					[value]="category"
					[checked]="category?.id === selectedCategory?.id"
					[labelPosition]="translate.currentLang == 'ar' ? 'after' : 'before'"
					class="w-[100%] p-4 rounded-md radio-aligment"
				>
					<div class="flex gap-4">
						<img
							class="w-10 rounded-full"
							[src]="attachmentPath + '/' + category?.imageUrl"
							alt=""
						/>
						<div>
							<p class="m-0 text-main-color-black">
								{{
									translate.currentLang == 'ar'
										? category?.name?.ar
										: category?.name?.en
								}}
							</p>
							<p class="m-0 text-[#6E7191] text-sm">
								{{ category?.serviceCount }}
								{{ 'SERVICE.SERVICE_TEMPLATE.SERVICE_COUNT' | translate }}
							</p>
						</div>
					</div>
				</mat-radio-button>
			</mat-radio-group>
		</div>
	</div>

	<div
		*ngIf="categories?.length"
		class="w-[70%] bg-white rounded-3xl text-center p-5 max-tablet:w-[100%] max-tablet:mt-7"
	>
		<div>
			<h2 class="mb-8">
				{{
					translate.currentLang === 'ar'
						? selectedCategory?.name?.ar
						: selectedCategory?.name?.en
				}}
			</h2>
			<mat-chip-listbox></mat-chip-listbox>
			<owl-carousel-o [options]="subCatOptions">
				<ng-template
					carouselSlide
					*ngFor="let subCat of subCategories; let i = index"
					[width]="subCat.width + 60"
				>
					<mat-chip-option
						class="w-full {{
							subCat?.id === selectedSubCategory
								? 'bg-gradient text-off-white'
								: 'justify-center text-medium-gray'
						}}"
						[value]="subCat.id"
					>
						<div
							(click)="onSubCategoryClicked(subCat)"
							class="flex items-center"
							[id]="'slide-' + i"
						>
							<mat-chip-avatar
								class="mx-1.5"
								*ngIf="subCat?.id === selectedSubCategory"
							>
								<img src="./assets/images/User Images.svg" />
							</mat-chip-avatar>
							<p
								class="m-0 whitespace-nowrap {{
									subCat?.id === selectedSubCategory
										? 'text-off-white'
										: 'text-medium-gray'
								}}"
							>
								{{
									translate.currentLang == 'ar'
										? subCat?.name?.ar
										: subCat?.name?.en
								}}
							</p>
						</div>
					</mat-chip-option>
				</ng-template>
			</owl-carousel-o>
			<div class="custom-table overflow-x-auto mt-5 mb-3">
				<table class="bg-transparent w-full">
					<thead class="bg-light">
						<tr>
							<!-- <td
								class="text-font-14 leading-[22px] text-medium-gray bg-off-white py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
							>
								<mat-checkbox
									[checked]="allServicesChecked"
									(change)="checkAllServices($event.checked)"
									class="text-medium-gray max-mobile:mb-3"
								>
								</mat-checkbox>
							</td> -->
							<td
								class="text-font-14 leading-[22px] text-medium-gray bg-off-white py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-start"
							>
								{{ 'SERVICE.SERVICE_TEMPLATE.SERVICE_NAME' | translate }}
							</td>

							<td
								class="text-font-14 leading-[22px] text-medium-gray bg-off-white py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-end"
							>
								{{ 'PACKAGES.DURATION' | translate }}
							</td>
						</tr>
					</thead>
					<tbody class="bg-grey-background">
						<tr
							class="text-[#4E4B66] border-b-[1px] border-secondry-color-Gray h-16"
							*ngFor="
								let service of services
									| paginate
										: {
												itemsPerPage: serviceFilter?.paging?.pageSize,
												currentPage: serviceFilter?.paging?.pageNumber,
												totalItems: totalCount
										  }
							"
						>
							<td class="text-start">
								<mat-checkbox
									#checkboxElements
									[checked]="isChecked(service.id)"
									(change)="checkService($event.checked, service)"
									class="text-medium-gray max-mobile:mb-3 px-[11px]"
								>
								</mat-checkbox>
								{{
									translate.currentLang == 'ar'
										? service?.name?.ar
										: service?.name?.en
								}}
							</td>

							<td class="text-end px-[30px]">
								{{
									service?.duration || ''
										| customDuration : translate.currentLang
								}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<!-- pagination -->
			<div class="py-5 max-mobile:overflow-auto">
				<app-pagination
					[totalCount]="totalCount"
					[pageNumber]="serviceFilter.paging.pageNumber"
					[pageCount]="serviceFilter.paging.pageSize"
					(currentPage)="
						serviceFilter.paging.pageNumber = $event; getServices()
					"
					(itemsCountPerPage)="
						serviceFilter.paging.pageSize = $event; getServices()
					"
				></app-pagination>
			</div>
			<div
				*ngIf="servicesObject?.length"
				class="flex justify-end mt-5 rounded-12"
			>
				<button
					(click)="onCancelled()"
					class="border border-solid border-[#D9DBE9] text-medium-gray bg-off-white hover:bg-gradient hover:text-off-white mx-2"
					mat-button
				>
					{{ 'ACTIONS.CANCEL' | translate }}
				</button>
				<button
					(click)="onSaved(); addServiceMode.emit(false); viewMode.emit(false)"
					class="bg-gradient text-off-white rounded"
					mat-button
				>
					{{ 'ACTIONS.ADD' | translate }}
				</button>
			</div>
		</div>
	</div>
</div>
<app-no-data-found
	*ngIf="!categories?.length"
	text="SERVICE.SERVICE_TEMPLATE.NO_SERVICES_TO_SHOW"
	[imageName]="'scissor.svg'"
></app-no-data-found>
